/* eslint-disable no-console */
/* eslint-disable no-undef */
import { Box, Container, makeStyles, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Header from './Header';
import axios from 'axios';
import Chat from './Chat';
import { useLocation } from 'react-router';
import { useFirebase, useFirestore } from 'react-redux-firebase';
import InputMessage from './InputMessage';

const useStyles = makeStyles({
  webchat: {
    background: 'white',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
  },
  colorTab: {
    padding: '0.4em',
  },
  powered: {
    margin: 0,
    fontSize: '10px',
    color: '#868686',
  },
  buttonLineaInt: {
    padding: '8px 16px',
    margin: '0 8px',
    border: 'none',
    color: 'white',
    cursor: 'pointer',
  },
});

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function Webchat() {
  const [configuration, setConfiguration] = useState(null);
  const [chat, setChat] = useState(null);
  const [tempMsgs, setTempMsgs] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [selectFile, setSelectFile] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [typeMessage, setTypeMessage] = useState('text');

  const firestore = useFirestore();
  const firebase = useFirebase();
  const query = useQuery();

  const organizationId = query.get('id');
  const phone = query.get('phone');
  const classes = useStyles({
    color: configuration ? configuration.mainColor : 'red',
  });
  const disabled = !!query.get('disabled');

  const login = (organizationId) => {
    return new Promise((resolve, reject) => {
      fetch(`${process.env.REACT_APP_GETCREDENTIALS_URL}/${organizationId}`)
        .then((res) => res.json())
        .then((res) => {
          if (res.token) {
            const token = res.token;
            firebase
              .auth()
              .signInWithCustomToken(token)
              .then(() => resolve())
              .catch((err) => {
                console.log('Failed firebase login with token', err);
                reject(err);
              });
          }
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  };
  async function getOrganization(organizationId) {
    const snapshot = await firestore.collection('organizations').doc(organizationId).get();
    const data = snapshot.data();
    // change for data.configuration
    const organization = {
      id: organizationId,
      mainColor: data.configuration.mainColor,
      name: data.displayName || data.name,
      image: data.configuration.image,
      createdAt: Date.now(),
      provider: data.provider.dfId,
      powered: data.softwareName,
      initialMessages: data.configuration.initialMessagesWeb,
    };
    setConfiguration(organization);
    localStorage.setItem('organization', JSON.stringify(organization));
  }

  const clearChat = () => {
    localStorage.removeItem('chat');
    setChat(null);
  };
  const enableFiles = (flag) => {
    setSelectFile(flag);
  };
  const onSendMessage = async ({ e, message = '', retry = true }) => {
    try {
      if (!message && newMessage) {
        setNewMessage('');
        setSelectFile(false);
      }
      if (e) e.preventDefault();
      const messageToSend = message || newMessage;
      if (!messageToSend) return;
      setTempMsgs([
        ...tempMsgs,
        {
          message: messageToSend,
          contentType: 'chat',
          type: 2,
          date: { seconds: Date.now() / 1000 },
        },
      ]);

      // Crea un objeto FormData y agrega el archivo y otros datos
      const formData = new FormData();
      formData.append('file', selectedFile);
      formData.append(
        'body',
        JSON.stringify({
          organizationId: configuration.id,
          query: { message: messageToSend, type: typeMessage },
          session: chat ? chat.session : null,
          phone,
        }),
      );
      const messageRequest = await axios.post(process.env.REACT_APP_DIALOGFLOW_URL, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      const messageResponse = messageRequest.data;

      if (messageResponse) {
        const hasChat = localStorage.getItem('chat') && JSON.parse(localStorage.getItem('chat'));
        const cacheChat = JSON.parse(localStorage.getItem('chat'));

        if (!hasChat || cacheChat.chatSession !== messageResponse.chatSession) {
          const chatSession = messageResponse.chatSession;

          if (chatSession) {
            setTimeout(async () => {
              const doc = await firestore
                .collection('chats')
                .where('session', '==', chatSession)
                .limit(1)
                .get();
              const chatData = doc && doc.docs && doc.docs[0];
              if (chatData) {
                const newChatCache = {
                  chatSession,
                  session: messageResponse.session,
                  id: chatData.id,
                  createdAt: Date.now(),
                  organizationId: query.get('id'),
                };
                setChat(newChatCache);
                localStorage.setItem('chat', JSON.stringify(newChatCache));
              }
            }, 10000);
          } else {
            clearChat();
            if (retry) {
              onSendMessage({ e, message, retry: false });
            }
          }
        }
        setSelectedFile(null);
        setTypeMessage('text');
      }
    } catch (error) {
      console.log('onSendMessage', error);
    }
  };

  useEffect(() => {
    if (!organizationId) return;
    const interval = setInterval(() => {
      login(organizationId);
    }, 1000 * 60 * 60 * 24); // each 24 hours needs a new token
    login(organizationId).then(() => {
      getOrganization(organizationId);
    });
    // set chat from local storage
    const chat = localStorage.getItem('chat') ? JSON.parse(localStorage.getItem('chat')) : null;
    if (chat && chat.organizationId) {
      if (chat.organizationId === organizationId) {
        const chatDate = new Date(chat.createdAt);
        const dayAgo = new Date(Date.now() - 1000 * 60 * 60 * 24);
        const actualDay = new Date();
        if (chatDate > dayAgo && chatDate.getDate() === actualDay.getDate()) {
          setChat(chat);
        } else {
          clearChat();
        }
      } else {
        clearChat();
      }
    }
    return () => {
      clearInterval(interval);
    };
  }, []);

  return !configuration ? (
    <Container className={classes.webchat}>
      {!organizationId && (
        <div
          style={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            // eslint-disable-next-line prettier/prettier
          }}
        >
          Debe ingresar un ID
        </div>
      )}
    </Container>
  ) : (
    <Container className={classes.webchat}>
      <Box className={classes.colorTab} style={{ background: configuration.mainColor }} />
      <Header organization={configuration.name.toUpperCase()} image={configuration.image} />
      <Chat
        color={configuration.mainColor}
        image={configuration.image}
        initialMessages={
          configuration.initialMessages &&
          configuration.initialMessages.map((message) => ({
            message: message,
            contentType: 'chat',
            creationDate: {
              seconds: parseInt(configuration.createdAt / 1000),
            },
            type: 0,
          }))
        }
        chatConfiguration={chat}
        chatId={(chat && chat.id) || ''}
        tempMsgs={tempMsgs}
        clearTemp={() => tempMsgs.length > 0 && setTempMsgs([])}
        onSendMessage={onSendMessage}
      />
      <InputMessage
        setTypeMessage={setTypeMessage}
        setSelectedFile={setSelectedFile}
        selectFile={selectFile}
        disabled={disabled}
        onSendMessage={onSendMessage}
        enableFiles={enableFiles}
      />
      <Typography align="center" className={classes.powered}>
        Powered by PrestoBots {configuration.powered && `+ ${configuration.powered}`}
      </Typography>
    </Container>
  );
}
